import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Vehicle } from '@commons/models/domain/Vehicle';

@Component({
  selector: 'app-e-toll-status',
  templateUrl: './e-toll-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ETollStatusComponent {

  @Input() public data: Vehicle;
  @Input() public isSentGeo?: boolean;

  constructor() { }

}
